import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '@app/components/components.module';
import { IconsModule } from '@app/app-icons.module';
import { StylesModule } from '@app/styles/styles.module';
import { DocumentsViewComponent } from './documents-view/documents-view.component';

@NgModule({
  declarations: [
    DocumentsViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    IconsModule,
    StylesModule
  ]
})
export class DocumentsModule { }
